<template>
  <div class="current_tickets">
    <h3 class="component_heading">{{ $t("tickets_and_bar.tickets.heading") }}</h3>
    <div class="tickets" v-if="orders.length > 0">
      <div class="ticket" v-for="(order, orderNum) in orders" :key="orderNum">
        <div class="left">
          <div
            class="poster-holder"
            :style="{ 'background-image': winW > 1024 ? 'none' : films[order.film].mob_poster ? 'url(https://multiplex.ua/' + films[order.film].mob_poster + ')' : 'url(/static/img/mob_poster_placeholder.jpg)' }"
          >
            <img :src="'https://multiplex.ua/' + films[order.film].inner_poster" class="poster" />
            <div class="poster-holder-mask"></div>
            <div class="poster-top" v-if="winW < 1024">
              <h4>
                <a
                  :href="'https://multiplex.ua/movie/' + films[order.film].id"
                >{{ films[order.film][$i18n.locale].title }}</a>
              </h4>
              <span class="button" @click="setTktQr(order, films[order.film][$i18n.locale].title)">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 0C.9 0 0 .9 0 2v6h4v2h2V8h2V0H2zm6 8v2H6v2H4v-2H2v2H0v6c0 1.1.9 2 2 2h8v-2H8v-2h2v2h2v-2h2v-2h4v-2h2v-2h-4v2h-2v-2h-2V8H8zm4 0h2v2h2V8h4V2c0-1.1-.9-2-2-2h-6v8zm6 6v2h2v-2h-2zm0 2h-2v2h2v-2zm0 2v2c1.1 0 2-.9 2-2h-2zm-2 0h-2v2h2v-2zM2 2h4v4H2V2zm12 0h4v4h-4V2zM3 3v2h2V3H3zm12 0v2h2V3h-2zm-7 9h2v2H8v-2zm-6 2h4v4H2v-4zm1 1v2h2v-2H3z"
                    fill="#FFF"
                    fill-rule="nonzero"
                  />
                </svg>
                <span>{{ $t("profile.show_cards") }} Qr код</span>
              </span>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="ticket-top">
            <h4 v-if="winW > 1024" class="ticket-heading">
              <a
                :href="'https://multiplex.ua/movie/' + films[order.film].id"
              >{{ films[order.film][$i18n.locale].title }}</a>
            </h4>
            <div class="ticket-buttons">
              <a class="button dl" :href="order.pdf_url" target="_blank">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                  <g fill="none" fill-rule="evenodd">
                    <path d="M0 0h20v20H0z" />
                    <path
                      d="M9 0v2h2V0H9zm0 4v8.586L5.707 9.293l-1.414 1.414L10 16.414l5.707-5.707-1.414-1.414L11 12.586V4H9zM0 15v3c0 1.093.907 2 2 2h16c1.093 0 2-.907 2-2v-3h-2v3H2v-3H0z"
                      fill="#FFF"
                      fill-rule="nonzero"
                    />
                  </g>
                </svg>
                <span>{{ $t("main_page.tickets.print") }}</span>
              </a>
              <div class="divider"></div>
              <span
                v-if="winW > 1024"
                class="button qr"
                @click="setTktQr(order, films[order.film][$i18n.locale].title)"
              >
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 0C.9 0 0 .9 0 2v6h4v2h2V8h2V0H2zm6 8v2H6v2H4v-2H2v2H0v6c0 1.1.9 2 2 2h8v-2H8v-2h2v2h2v-2h2v-2h4v-2h2v-2h-4v2h-2v-2h-2V8H8zm4 0h2v2h2V8h4V2c0-1.1-.9-2-2-2h-6v8zm6 6v2h2v-2h-2zm0 2h-2v2h2v-2zm0 2v2c1.1 0 2-.9 2-2h-2zm-2 0h-2v2h2v-2zM2 2h4v4H2V2zm12 0h4v4h-4V2zM3 3v2h2V3H3zm12 0v2h2V3h-2zm-7 9h2v2H8v-2zm-6 2h4v4H2v-4zm1 1v2h2v-2H3z"
                    fill="#FFF"
                    fill-rule="nonzero"
                  />
                </svg>
                <span>Qr-код</span>
              </span>
              <span class="button return" @click="showQuestionRefund(order)">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                  <g fill="none" fill-rule="evenodd">
                    <path d="M0 0h20v20H0z" />
                    <path
                      d="M5.129 1.967a.747.747 0 0 0-.404.195L.293 6.272a.999.999 0 0 0 0 1.414l4.432 4.11A.76.76 0 0 0 6 11.239V8h7.5c2.48 0 4.5 2.02 4.5 4.5S15.98 17 13.5 17H13a1 1 0 1 0 0 2h.5c3.57 0 6.5-2.93 6.5-6.5S17.07 6 13.5 6H6V2.72a.761.761 0 0 0-.871-.753zM5 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                      fill="#FFF"
                      fill-rule="nonzero"
                    />
                  </g>
                </svg>
                <span>{{ $t("main_page.tickets.return") }}</span>
              </span>
            </div>
          </div>
          <div class="ticket-body">
            <div class="kvs">
              <div class="kv">
                <p class="key">{{ $t("main_page.tickets.num_tickets") }}</p>
                <p class="val">{{ order.tickets.length }}</p>
              </div>
              <div class="kv">
                <p class="key">{{ $t("main_page.tickets.date_start") }}</p>
                <p class="val">{{ order.dateStr }}, {{ order.timeStr }}</p>
              </div>
              <div class="kv">
                <p class="key">{{ $t("main_page.tickets.cinema") }} / зал</p>
                <p class="val">
                  <a
                    :href="'https://multiplex.ua/cinema/' + dicts.cinemasById[order.cinema].url"
                  >{{ dicts.cinemasById[order.cinema].name }} / {{ order.screen_name }}</a>
                </p>
              </div>
              <div class="kv">
                <p class="key">{{ $t("main_page.tickets.address") }}</p>
                <p
                  class="val"
                >{{ dicts.citiesById[dicts.cinemasById[order.cinema].city_id].name }}, {{ dicts.cinemasById[order.cinema].address }}</p>
              </div>
              <div class="kv">
                <p class="key">{{ $t("main_page.tickets.order_num") }}</p>
                <p class="val">{{ order.booking_number }}</p>
              </div>
              <div class="kv" v-if="order.bar.length > 0">
                <p class="key">{{ $t("main_page.tickets.bar_goods") }}</p>
                <div class="val">
                  <div class="bar_items">
                    <div class="bar_pos" v-for="(barpos, barposnum) in order.bar" :key="barposnum">
                      <p class="qty">{{ barpos.qty }}шт</p>
                      <p class="name">{{ items[barpos.item].name }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="notickets" v-else>
      {{ $t("main_page.tickets.no_tickets") }}.
      <a
        href="https://multiplex.ua"
      >{{ $t("main_page.tickets.time_to_buy") }}</a>
    </p>

    <modal-popup-black
      v-show="isShowQuestionRefund"
      :title="'Повернення замовлення'"
      :text="'Ви дійсно хочете повернути замовлення?'"
      :textBtnPrimary="$t(`pop_ups.connect_your_open_id.btns.primary`)"
      :textBtnSecondary="$t(`pop_ups.connect_your_open_id.btns.secondary`)"
      @eventBybtnPrimary="modalQuestionRefundOk"
      @eventBybtnSecondary="modalQuestionRefundNo"
      @eventBybtnCrissCross="modalQuestionRefundCrissCross"       
    />

    <modal-popup-black
      v-show="isShowModalServerMessage"
      :title="'Повернення замовлення'"
      :text="modalMessage"
      :textBtnPrimary="$t(`pop_ups.connect_your_open_id.btns.primary`)"
      :isShowBtnSecondary="false"
      :textBtnSecondary="''"
      @eventBybtnPrimary="modalServerMessage"
      @eventBybtnSecondary="modalServerMessage"
      @eventBybtnCrissCross="modalServerMessage"      
    />

    <preloader-anim v-if="isShowPreloader"></preloader-anim>
  </div>
</template>
<script>
import Store from '../../store'
export default {
  data: function () {
    return {
      // Чи потрібно звернутись до сервера за новими Order та History.
      isRepeatRequest: false,
      // Рахує, скільки разів звернулись до сервера
      qtyAskServer: 0,
      // Замовлення яке повертається
      orderThatRefund: undefined,
      isShowPreloader: false,
      isShowModalServerMessage: false,
      // Захист від помилки. Показує модальне вікно "Повернення": так, ні
      isShowQuestionRefund: false,
      modalMessage: ''
    }
  },
  computed: {
    orders: function () {
      return Store.state.currentOrders
    },
    films: function () {
      return Store.state.currentFilms
    },
    dicts: function () {
      return Store.getters.dicts()
    },
    items: function () {
      return Store.state.currentItems
    },
    winW: function () {
      return Store.state.winW
    }
  },
  methods: {
    setTicketsForShare: function (tickets) {
      Store.commit('setTicketsForShare', tickets)
    },
    setTktQr: function (order, movie) {
      Store.commit('setTktQrOrder', order)
      Store.commit('setTktQrMovie', movie)
    },
    showQuestionRefund: function (order) {
      this.orderThatRefund = order
      this.isShowQuestionRefund = true
    },
    modalQuestionRefundOk: function () {
      this.refundOrder()
      this.modalQuestionRefundCrissCross()
    },
    modalQuestionRefundNo: function () {
      this.modalQuestionRefundCrissCross()
    },
    modalQuestionRefundCrissCross: function () {
      this.isShowQuestionRefund = false
    },
    refundOrder: function () {
      this.isShowPreloader = true

      let params = JSON.stringify({
        cinemas: this.orderThatRefund.cinema_vista_id,
        transNumber: this.orderThatRefund.transaction_number,
        uLang: 'ua || ru'
      })

      this.$http
        .post('https://gate.multiplex.ua/', {
          'command': 'automaticrefund',
          'params': params,
          'SessionId': null,
          'Client': 'siteMX'
        })
        .then(
          (response) => {
            this.proccessResponse(response)
          },
          (response) => {
            this.proccessResponse(response)
          }
        )
    },
    proccessResponse: function (response) {
      if (response.body.Data !== '') {
        let Data = JSON.parse(response.body.Data)
        // If Order still not refunded then Data.status === 'info'.
        // If Order refunded then Data.status === 'ok'
        if (response.body.Success === '0' && Data.status === 'ok') {
          this.isRepeatRequest = true
        }
        this.modalMessage = Data.message
        this.isShowModalServerMessage = true
      }
      this.isShowPreloader = false
    },
    /**
     * Показується Прелоадер.
     * Ховається Чорне мадальне вікно.
     * З сервера тянуться свіжі дані по Order та History.
     * Перевіряємо чи є номер транзакції в CurrentOrder.
     * Якщо є, тоді залишаємо прелоадер і питаємо сервер знову.
     * Якщо номера транзакції немає в CurrentOrder - отже дані на екрані оновлятья, тому виходимо з методу.
     * Перевірку робимо 5 разів з інтервалом 500 мілісекунд.
     */
    modalServerMessage: function () {
      this.isShowModalServerMessage = false

      if (this.isRepeatRequest) {
        this.isShowPreloader = true

        Store.dispatch('getCurrentOrders', () => {
          Store.dispatch('getHistoryOrders', true)
        })

        let isRefundedTransactionNumber = this.orders.find(e => this.orderThatRefund.transaction_number === e.transaction_number)
        if (isRefundedTransactionNumber) {
          if (this.qtyAskServer < 5) {
            this.qtyAskServer++
            setTimeout(() => this.modalServerMessage(), 500)
          }
        }

        this.isRepeatRequest = false
        this.isShowPreloader = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// tickets.vue?7c4d4d66